export function isValidIranianCompanyNationalId(code: string): boolean {
  if (code.length !== 11) return false

  if (parseInt(code, 10) === 0) return false

  if (parseInt(code.slice(3, 9), 10) === 0) return false

  const controlDigit = parseInt(code.slice(10, 11), 10)
  const tenthDigitPlusTwo = parseInt(code.slice(9, 10), 10) + 2
  const coefficients = [29, 27, 23, 19, 17]
  let sum = 0

  for (let i = 0; i < 10; i++) {
    sum +=
      (tenthDigitPlusTwo + parseInt(code.slice(i, i + 1), 10)) *
      coefficients[i % 5]
  }

  let remainder = sum % 11

  if (remainder === 10) remainder = 0

  return controlDigit === remainder
}
